export enum DataSubjectUrl {
  DATASUBJECT = '/data-subjects{/id}{?page,size,sort*,search,businessArea,economicSector,legalForm,isFictitious,isPublic,selectedSubject}',
  DATASUBJECT_INPUTS = '/data-subjects/{id}/inputs{?page,size,sort,valueDate}',
  DATASUBJECT_HISTORY = '/data-subjects/{id}/history{?page,size,sort,classifierId*,value,validFrom,validTo}',
  DATASUBJECT_UPDATE_FROM_MYR = '/data-subjects{/code}/update-from-myr',
}
